import React from "react";
import styles from "./Download.module.css";
import {
  BlogForumsIcon,
  CloseIcon,
  DownloadIconProgress,
  PrintOnlineIcon,
  SocialAccountsIcon,
} from "../Icons/icons.component";

const DownloadPopup = ({
  isSocial,
  IsPrintAndOnline,
  IsBlogAndForum,
  clicked,
  showList,
}) => {
  const renderDownloadProgresssList = () => {
    const ul = document.getElementById("ul_o");
    const count = ul ? ul.childElementCount : 0;
    return (
      <>
        {showList && (
          <div>
            <div className={styles.downloadList}>
              <div className={styles.closeicon}>
                <div onClick={() => clicked(false)}>
                  <CloseIcon />
                </div>
              </div>
              <ul id="ul_o">
                {IsPrintAndOnline && (
                  <li className={styles.orangeColor}>
                    <PrintOnlineIcon />
                    Print Online report is downloading.!
                  </li>
                )}
                {isSocial && (
                  <li className={styles.blueColor}>
                    <SocialAccountsIcon /> Social media report is downloading.!
                  </li>
                )}
                {IsBlogAndForum && (
                  <li className={styles.purpleColor}>
                    <BlogForumsIcon /> Blogs report is downloading.!
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <div className={styles.body}>
      <a className={styles.downloadicon} onClick={() => clicked(true)}>
        <DownloadIconProgress />
      </a>
      {renderDownloadProgresssList()}
    </div>
  );
};

export default DownloadPopup;
